import { render, staticRenderFns } from "./multipleChoicePicker.vue?vue&type=template&id=50b38cea&scoped=true"
import script from "./multipleChoicePicker.vue?vue&type=script&lang=ts"
export * from "./multipleChoicePicker.vue?vue&type=script&lang=ts"
import style0 from "./multipleChoicePicker.vue?vue&type=style&index=0&id=50b38cea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b38cea",
  null
  
)

export default component.exports